import { RefObject } from 'react';

import useMeasure from '../../../hooks/useMeasure';

const useFadeVisible = (
    containerRef: RefObject<HTMLDivElement>,
    contentRef: RefObject<HTMLDivElement>,
    dragX: number,
    mode: 'transform' | 'scroll',
    threshold = 5
) => {
    const containerWidth = useMeasure(containerRef).width;
    const contentWidth = useMeasure(contentRef).width;

    if (mode === 'scroll') {
        return {
            hideFadeRight: contentWidth - containerWidth - dragX <= threshold,
            hideFadeLeft: dragX <= threshold,
            draggable: contentWidth < containerWidth,
        };
    }

    return {
        hideFadeRight: containerWidth - contentWidth - dragX > -threshold,
        hideFadeLeft: dragX > -threshold,
        draggable: containerWidth < contentWidth,
    };
};

export default useFadeVisible;
